<template>
  <div class="setHeader">
    <Header class="header" v-if="!$route.meta.singleHead"></Header>
    <div id="conentHeight">
      <!-- <keep-alive> -->
      <keep-alive>
        <router-view class="setOther" v-if="$route.meta.keepAlive"/>
      </keep-alive>
      <router-view class="setOther" v-if="!$route.meta.keepAlive" />
    </div>
    <batch-verify-view :dialogObj="verifyArgs"></batch-verify-view>
  </div>
</template>
<script>
import Header from "@components/header";
import bus from "@config/bus";
import { mapState } from "vuex";
import batchVerifyView from '../components/batchVerify.vue'
import api from '../config/publicFundChangeApi'
export default {
  data() {
    return {
      keepAlive:["uploadMaterial"],
      verifyArgs:{
        BooleanConfirm:false,
        BooleanCancel:false,
        dynamicConfirmText:'',
        dynamicCancelText:'',
        dynamicTipsContent:'',
        showTipsRisk:false,
        tipsCode:0,
      }
    };
  },
  mounted() {
    this.loadingData();
  },
  computed: {
    ...mapState(["setHeader", "statusHeight","childProId","verifyStatus","newPersonalAccount","deviceInfo"]),
  },
  watch: {
    //监听弹框事件
     verifyStatus:{
      handler(val){
       if(val.status === '1'){
        this.verifyCustomerInfo(val)
       }else if(val.status === '0'){
        this.verifyArgs.showTipsRisk = false
       }
      },
      deep:true
    },
    $route(to, from) {
      //调试
     // b -> a :不缓存b
       if(from.path == '/uploadMaterial1' && to.path == '/investorIdentification1') {//b a
         this.keepAlive = []
       }
        if(from.path == '/investorIdentification1' && to.path == '/uploadMaterial1') {//b a
         this.keepAlive =  ['uploadMaterial']
       }
       if(from.path == '/uploadMaterial1' && to.path == '/searchExample') {//b a
         this.keepAlive = ['uploadMaterial']
       }
       const isMethodRegistered = dsBridge.hasNativeMethod('responseRequest');
       //dsbridge方法兼容
       if (isMethodRegistered) {
          if (to.path == "/index" || to.path == "/assets") {
              dsBridge.call("responseRequest", { requestType: 'showHomeTabbar' })
          } else {
                dsBridge.call("responseRequest", { requestType: 'hiddenHomeTabbar' }) 
          }
       }
     },
    statusHeight: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.$nextTick(() => {
            let heig = Number(this.statusHeight.statusBar_height);
            let newH = heig + 48;
            let data = newH / 100 + "rem";
            let $dom = document.getElementById("conentHeight");
            $dom.style.marginTop = data;
            $dom.style.height = `calc(100vh - ${data})`;
          });
        }
      },
      deep: true,
      immediate: true
    },
    '$store.state.getHeadInfo.company'(val){
      if(val){
       this.getPhoneInfo();
       this.getUserInfo();
      }
    }
  },
  methods: {
    //校验用户资质
    verifyCustomerInfo(val){
      const {orgCommonId = '',groupCommonId = '',userType = '1',name = '',shlxLoginPersonType=''} = this.newPersonalAccount
      let params = {
           orgCommonId,
           groupCommonId,
           loginType:userType,
           customerName:name,
           orgLoginType:shlxLoginPersonType
        }
        if(val.source === 'optional'){
            this.$post(api.batchCustomerVerification,params).then((res)=>{
              if(res.code === 10000){
                localStorage.removeItem('choiceList')
                  let parameter = {
                    ...params,
                    ...val.args
                  }
                  return
                  this.$post(val.baseUrl,parameter).then((vo)=>{
                    if(vo.code === 10000){
                      this.$router.push({
                          // path:'/shoppingCartIndex',
                          path:'/shoppingCartModule',
                          query:{
                            from:'optional'
                          }
                      })
                    }
                  })
              }else{
                  this.verifyArgs.tipsCode = res.code
                  if(res.code === 80080){ //个人证件有效期过期
                      this.verifyArgs.BooleanConfirm = true
                      this.verifyArgs.BooleanCancel = true
                      this.verifyArgs.dynamicConfirmText = '去修改'
                      this.verifyArgs.dynamicCancelText = '取消'
                      this.verifyArgs.dynamicTipsContent = '您的证件已过期，请修改证件有效期后进行交易。'
                      this.verifyArgs.showTipsRisk = true
                  }else if(res.code === 80081){ //机构证件/法人证件/经办人证件/经办人授权有效期过期
                      this.verifyArgs.BooleanConfirm = true
                      this.verifyArgs.dynamicConfirmText = '确认'
                      this.verifyArgs.dynamicTipsContent = `您的${res.data.result}已过期，请联系您的财富顾问或联系客服，修改证件有效期后进行交易。`
                      this.verifyArgs.showTipsRisk = true
                  }else if(res.code === 80014){ //陆享基金账户审批中
                      this.verifyArgs.BooleanConfirm = true
                      this.verifyArgs.dynamicConfirmText = '确认'
                      this.verifyArgs.dynamicTipsContent = '您的陆享账户正在审核中，请联系您的财富顾问，开户成功后您可以进行批量买入。'
                      this.verifyArgs.showTipsRisk = true
                  }else if(res.code === 80023){ //集团账户审批
                      this.verifyArgs.BooleanConfirm = true
                      this.verifyArgs.dynamicConfirmText = '确认'
                      this.verifyArgs.dynamicTipsContent = '您的开户申请正在审核中，无法进行批量买入。'
                      this.verifyArgs.showTipsRisk = true
                  }else if(res.code === 80027){ //陆享基金账户未开通
                      let params = {
                          requestType: "the_service_screen_is_displayed",
                          requestData: {
                              nextPageUrl:"myChoice",
                              orgCommonId:this.newPersonalAccount?.orgCommonId,//公司客户公共表主键ID
                              groupCommonId:this.newPersonalAccount?.groupCommonId,//集团公共表id
                              groupId:this.newPersonalAccount?.groupCommonId,//集团公共表id
                              companyId:this.newPersonalAccount.company,
                              ip:this.deviceInfo.deviceNowIp,
                              deviceId:this.deviceInfo.deviceId,
                              eye_open:this.newPersonalAccount.eye_open ? this.newPersonalAccount.eye_open : false,
                              userType:this.newPersonalAccount?.userType,//0-机构 1-个人
                              code:80027,
                              message:'您尚未开通陆享基金主体账户，请先完成开户。'
                          }
                      };
                      if (this.IOS.ios()) {
                          window.webkit.messageHandlers.requestEventData.postMessage(params);
                      } else {
                          window.android.requestEventData(JSON.stringify(params));
                      }
                  }
              }
          })
        }else{
          if(val.source === 'addFund'){
            let req = {
              ...params,
              productIdList:val.args.productIdList
            }
            this.$post(val.baseUrl, req).then((res) => {
              if (res.code === 10000) {
                let obj = {
                  page:'addShoppingCart',
                  status:'1'
                }
                this.$store.commit('controlLayerStatus',obj)
              } else {
                this.$toast(res.message);
              }
            });
          }else{//加购物车
            let parameter={
              ...params,
              productIdList:val.productIdList,
            }
            this.$post(api.addShoppingCart, parameter).then((res) => {
              if (res.code === 10000) {
                this.$toast('添加成功');
              } else {
                this.$toast(res.message);
              }
            });
          }
        }

    },
     //获取手机设备信息
    getPhoneInfo() {
      let params = {
        requestType: 'get-native-device-info-data',
        requestData: {},
      };
      if(this.$store.state.getHeadInfo.company==1){
        if (this.IOS.ios()) {
          window.webkit.messageHandlers.requestEventData.postMessage(params);
        } else {
          window.android.requestEventData(JSON.stringify(params));
        }
      }
    },
    getUserInfo() {
      let params = {
        requestType: "get-user-info-data-to-h5",
        requestData: {}
      };
      if(this.$store.state.getHeadInfo.company==1){
        if (this.IOS.ios()) {
          window.webkit&&window.webkit.messageHandlers&&window.webkit.messageHandlers.requestEventData&&window.webkit.messageHandlers.requestEventData.postMessage&&window.webkit.messageHandlers.requestEventData.postMessage(params)
        }else{
          window.android&&window.android.requestEventData&&window.android.requestEventData(JSON.stringify(params));

        }
      }
    },
    loadingData() {
      if (this.IOS.ios()) {
        window.getCommonKey = this.getCommonKey;
        window.getHead = this.getHeadInfo;
        window.getChildId = this.getChildId;
        window.userRiskLevel = this.getUserRiskLevel;
        window.personOpenAccount = this.getOpenAccount;
        window.transStatusBarHeight = this.getBarHeight;
        window.getPublicInfo = this.publicBaseInfo;
        window.authenticationForKey = this.getTurnRouter;
        window.approveParams = this.getRiskEvaluationParams;
        window.getOrgID = this.getOrgDetailID;
        window.personalCenter = this.getPersonalCenter;
        window.personalAccount = this.getPersonalAccount;
        window.realInfo = this.getPersonalRealInfo;
        // window.newPersonalAccount=this.getNewPersonalAccount;
        window["responseEventData"] = (val) => {
            console.log('responseEventData==', val);
             //私募详情 底部添加文案提示
          if(val.requestType == 'get_product_compliance_copy_prompts'){
            this.$store.commit("setCopyPrompts",val.responseData);
          }
          // 存储用户信息
          if(val.requestType == 'get-user-info-data-to-h5'|| val.requestType =='get-user-info-data-by-user-login') {
            console.log("用戶信息---");
            console.log(val.responseData);
            this.getNewPersonalAccount(val.responseData)
          }
          // 判断是否需要调用原生返回
          if(val.requestType == 'open-page-h5-first-init-data') {
            this.$store.commit("changePageSource",val.responseData.pageSource);
          }
           //财经早餐id
          if(val.requestType == 'share-outside-share-to-app-page') {
            if(JSON.parse(val.responseData).openUrlPageData?.type=='previousProductMarketingPage') {
              this.$store.commit("setShareObj",JSON.parse(val.responseData).openUrlPageData);
            } else if(JSON.parse(val.responseData).openUrlPageData?.type=='shoppingCar'){//购物车
              this.$store.commit("setShareObj",JSON.parse(val.responseData).openUrlPageData);
            }else if(JSON.parse(val.responseData).openUrlPageData?.type=='screening'){//基金筛选
              this.$store.commit("setScreeningObj",JSON.parse(val.responseData).openUrlPageData);
            }else{
              this.$store.commit("changeOpenId",JSON.parse(val.responseData).openUrlPageData);
            }
          }
          //原生通知h5需要去截图
          if(val.requestType == 'shareImageCallback') {
            this.$store.commit("changeShareImage",true);
          }
          // 原生给h5返回手机信息
          if(val.requestType == 'get-native-device-info-data') {
            console.log('原生给h5返回手机信息');
            console.log(val.responseData);
            console.log(val.responseData.deviceId);
            this.$store.commit("userPhoneInfo", val.responseData.deviceId);
            this.$store.commit("changeDeviceInfo", val.responseData);
          }
          // 通知H5 ，当前加载页面得状态变化
          if(val.requestType == 'status-native-page-status-change') {
            // console.log('通知H5 ，当前加载页面得状态变化');
            // console.log(val);
            // console.log(val.responseData);
            // console.log(val.responseData.pageStatus);
            this.$store.commit("getPageStatus", val.responseData.pageStatus);
          }
          // 原生进入筛选页面
          if(val.requestType == 'initial-release-of-fund-screening-page') {
            console.log('原生进入筛选页面',);
            console.log(val.responseData);
            this.$store.commit("getScreeningInfo", val.responseData);
          }
          //索取H5推送到原生的埋点数据
          if(val.requestType == 'get_buried_point_data_to_native') {
            console.log('索取H5推送到原生的埋点数据',);
            console.log(val.responseData);
            this.$store.commit("getBuriedInfo", val.responseData);
          }
          // 原生给h5返回购物车蒙城
          if(val.requestType == 'the_show_guide_mask') {
            console.log('原生给h5返回购物车蒙城');
            console.log(val.responseData);
            this.$store.commit("getLayerFromNative", val.responseData);
          }
          // 监听取值事件
          if(val.requestType == 'get-data-in-native-cache') {
            if(val.responseData?.stockAndBond?.activeId) {
              this.$store.commit("changeStockAndBond", val.responseData?.stockAndBond);
            }
            if(val.responseData?.data?.isVertical === false ) {
              val.responseData?.data?.deletedList?.forEach(item => {
                bus.$emit('removeOptionalFund',item)
              })
              this.$router.push('/fundContrast')
              // 存数据
              const params = {
                  requestType: 'save-data-to-native-cache',
                  requestData: {
                    key: 'data',
                    value: {
                      isVertical: true,
                      deletedList: []
                    }
                  }
              };
              if(this.$store.state.getHeadInfo.company==1){
                    if (this.IOS.ios()) {
                        window.webkit.messageHandlers.requestEventData.postMessage(params);
                    } else {
                        window.android.requestEventData(JSON.stringify(params));
                    }
                }
            }
            if(val.responseData?.data?.pkId) {
                const { pkId, type, deletedList, tabName, actionKey, actionKey2 } = val.responseData?.data
                let params = {
                  tabName,
                  pkId,
                  type,
                  deletedList,
                  actionKey,
                  actionKey2
                };
                this.$store.commit("changePkInfo", params);
            }
            if(val.responseData?.data?.contrastItem?.id) {
                const { activeRange, contrastItem } = val.responseData?.data
                let params = {
                  activeRange,
                  contrastItem
                };
                this.$store.commit("changePkInfo", params);
            }
          }
        };
      } else {
        // console.log('responseEventData==', val);
        // 安卓传值给h5
        window["responseEventData"] = (val) => {
          // console.log('responseEventData444安卓', val,);
          //私募详情 底部添加文案提示
          if((JSON.parse(val)).requestType == 'get_product_compliance_copy_prompts'){
            this.$store.commit("setCopyPrompts",JSON.parse(val).responseData);
          }
            //财经早餐保存图片
          if(val.requestType == 'refresh_status_in_screening_page') {
            this.$store.commit("changeHideView", val.responseData&&val.responseData.hideView);
          }

          // 存储用户信息
          if((JSON.parse(val)).requestType == 'get-user-info-data-by-user-login'||(JSON.parse(val)).requestType == 'receive-native—send-login-info'||(JSON.parse(val)).requestType == 'get-user-info-data-to-h5' ) {
            // console.log(val,'val+++++++++++')
            this.getNewPersonalAccount(val)
          }
            //财经早餐id
          if((JSON.parse(val)).requestType == 'share-outside-share-to-app-page') {
            if(JSON.parse(val).responseData?.type === 'previousProductMarketingPage') {
              this.$store.commit("setShareObj",JSON.parse(val).responseData);
            } else if(JSON.parse(val).responseData?.type=='shoppingCar'){//购物车
              this.$store.commit("setShareObj",JSON.parse(val).responseData);
            }else if(JSON.parse(val).responseData?.type=='screening'){
              this.$store.commit("setScreeningObj",JSON.parse(val).responseData);
            }else{
              this.$store.commit("changeOpenId",JSON.parse(val).responseData.id);
            }
          }
          // 判断是否需要调用原生返回
          if((JSON.parse(val)).requestType == 'open-page-h5-first-init-data') {
            console.log('goback', JSON.parse(val));
            this.$store.commit("changePageSource", JSON.parse(val).responseData&&JSON.parse(val).responseData.pageSource);
          }
          // 原生给h5返回手机信息
          if((JSON.parse(val)).requestType == 'get-native-device-info-data') {
            // console.log('原生给h5返回手机信息',);
            // console.log(JSON.parse(val).responseData.deviceId);
            // console.log(JSON.parse(val).responseData,'JSON.parse(val).responseData')
            this.$store.commit("userPhoneInfo", JSON.parse(val).responseData&&JSON.parse(val).responseData.deviceId);
            this.$store.commit("changeDeviceInfo", JSON.parse(val).responseData);
          }
          // 通知H5 ，当前加载页面得状态变化
          if((JSON.parse(val)).requestType == 'status-native-page-status-change') {
            console.log('通知H5 ，当前加载页面得状态变化',);
            console.log(JSON.parse(val).responseData.pageStatus);
            this.$store.commit("getPageStatus", JSON.parse(val).responseData&&JSON.parse(val).responseData.pageStatus);
          }
          // 原生进入筛选页面
          if((JSON.parse(val)).requestType == 'initial-release-of-fund-screening-page') {
            console.log('原生进入筛选页面',);
            // console.log(JSON.parse(val).responseData);
            this.$store.commit("getScreeningInfo", JSON.parse(val).responseData);
          }
          //索取H5推送到原生的埋点数据
          if((JSON.parse(val)).requestType == 'get_buried_point_data_to_native'||(JSON.parse(val)).requestType == 'save_buried_point_data_to_native') {
            console.log('索取H5推送到原生的埋点数据',);
            // console.log(JSON.parse(val).responseData);
            this.$store.commit("getBuriedInfo", JSON.parse(val).responseData);
          }
          // console.log(JSON.parse(val).requestType,'val.requestTypew345')
          // console.log(JSON.parse(val).requestType == 'the_show_guide_mask','val.requestType345345')
           // 原生给h5返回购物车蒙城
           if(JSON.parse(val).requestType == 'the_show_guide_mask') {
            console.log('原生给h5返回手机信息');
            // console.log(JSON.parse(val).responseData);
            this.$store.commit("getLayerFromNative", JSON.parse(val).responseData);
          }
          // 购物车买入成功传参
          if(JSON.parse(val).requestType == 'page_need_reload_new_url') {
            console.log('原生给h5返回手机信息购物车买入成功传参');
            // console.log(JSON.parse(val).responseData);
            this.$store.commit("getBatchOrderReturnInfo", JSON.parse(val).responseData);
          }
          // 监听取值事件
          if((JSON.parse(val)).requestType == 'get-data-in-native-cache') {
            if(JSON.parse(val).responseData?.key === 'stockAndBond'&& JSON.parse(val).responseData?.value?.activeId) {
              this.$store.commit("changeStockAndBond", JSON.parse(val).responseData?.value);
            }
            if(JSON.parse(val).responseData?.value?.isVertical === false ) {
              JSON.parse(val).responseData?.value?.deletedList?.forEach(item => {
                bus.$emit('removeOptionalFund',item)
              })
              this.$router.push('/fundContrast')
              // 存数据
              const params = {
                  requestType: 'save-data-to-native-cache',
                  requestData: {
                    key: 'data',
                    value: {
                      isVertical: true,
                      deletedList: []
                    }
                  }
              };
              if(this.$store.state.getHeadInfo.company==1){
                    if (this.IOS.ios()) {
                        window.webkit.messageHandlers.requestEventData.postMessage(params);
                    } else {
                        window.android.requestEventData(JSON.stringify(params));
                    }
                }
            }
            if(JSON.parse(val).responseData?.value?.pkId) {
              const { pkId, type, deletedList, tabName, actionKey, actionKey2 } = JSON.parse(val).responseData?.value
              let params = {
                tabName,
                pkId,
                type,
                deletedList,
                actionKey,
                actionKey2
              };
              this.$store.commit("changePkInfo", params);
            }
            if(JSON.parse(val).responseData?.value?.contrastItem?.id) {
                const { activeRange, contrastItem } = JSON.parse(val).responseData?.value
                let params = {
                  activeRange,
                  contrastItem
                };
                this.$store.commit("changePkInfo", params);
            }
          }
          // H5返回到App
          // if((JSON.parse(val)).requestType == 'get-user-info-data-to-h5'){
          //   this.$store.commit("newPersonalAccount", JSON.parse(val).responseData);
          // }
        }
        window["personalAccount"] = (val) => {
          //新发基金
          this.getPersonalAccount(val);
        };
        window["getCommonKey"] = (val) => {
          this.getCommonKey(val);
        };
        window["setHeader"] = (val) => {
          this.getHeadInfo(val);
        };
        window["getChildId"] = (val) => {
          this.getChildId(val);
        };
        window["userRiskLevel"] = (val) => {
          this.getUserRiskLevel(val);
        };
        window["personOpenAccount"] = (val) => {
          this.getOpenAccount(val);
        };
        window["personalWindTestData"] = (val) => {
          this.getOpenAccount(val);
        };
        window["getOpenAccount"] = (val) => {
          this.getOpenAccount(val);
        };
        window["transStatusBarHeight"] = (val) => {
          this.getBarHeight(val);
        };
        window["getPublicInfo"] = (val) => {
          this.publicBaseInfo(val);
        };
        window["testForKey"] = (val) => {
          this.getTurnRouter(val);
        };
        window["approveParams"] = (val) => {
          this.getRiskEvaluationParams(val);
        };
        window["getOrgID"] = (val) => {
          //机构详情id
          this.getOrgDetailID(val);
        };
        window["personalCenter"] = (val) => {
          //个人中心
          this.getPersonalCenter(val);
        };
        window["personalRealInfo"] = (val) => {
          //个人-实名信息
          this.getPersonalRealInfo(val);
          this.getPersonalAccount(val);
        };
        window["androidData"] = (val) => {
          //安卓传值--存续
          this.getPersonalAccount(val);
        };
         window["personalBankAccount"] = (val) => {
          //个人-账户信息
          this.getPersonalAccount(val);
        };
         window["getAssetsInfo"] = (val) => {
          //个人-申请资产信息
          this.getAssetsApprove(val);
        };
      }
    },
    getRiskEvaluationParams(val) {
      if (!this.IOS.ios()) {
        val = JSON.parse(val);
      }
      if (val) {
        this.certificateNo = val.certificateNo;
        this.riskEvaluationParams = val;
      }
    },
    // 获取请求头信息
    getHeadInfo(val) {
      if (!this.IOS.ios()) {
        val = JSON.parse(val);
      }
      let platform = val.entranceJudgment;
      this.$store.commit("savePlatform", platform);
      let id = val.groupCommonId;
      this.$store.commit("getOrgCommonId", id);
      this.$store.dispatch("getSetHeader", val);
    },
    getTurnRouter(val) {
      if (val) {
        let typeVal;
        if (!this.IOS.ios()) {
          typeVal = JSON.parse(val);
        } else {
          typeVal = val;
        }
        console.log(val,'val')
        this.$store.commit("getClickType", typeVal.signleType);
        if (typeVal.name) {
          let arr;
          if (!this.IOS.ios()) {
            arr = typeVal.name;
          } else {
            arr = typeVal.name.split(",");
          }
          let routerList = [...arr];
          this.$store.commit("changePathList", routerList);
          arr.shift();
          this.$store.commit("getTurnPage", arr);
        }
      }
    },
    // 获取请求头信息
    getCommonKey(val) {
      if (!this.IOS.ios()) {
        val = JSON.parse(val);
      }
      this.$store.commit("getCommonInfo", val);
    },
    //获取开户信息
    getOpenAccount(val) {
      this.getPersonalAccount(val);
      if (!this.IOS.ios()) {
        val = JSON.parse(val.replace(/\n/g,"\\n").replace(/\r/g,"\\r"));
      }
      if (val.code) {
        let personObj = {
          code: val.code,
          groupPid: val.groupPid,
          commonId: val.commonId,
        };
        this.$store.commit("fillUserInfo", personObj);
      }
      if (val.saleType) {
        this.$store.commit("getSaleType", val.saleType);
      }
      this.$store.commit("changeInfo", val.name);
      this.$store.dispatch("getOpenAccount", val);
      ///如果是OCR处理逻辑
      if (val.scanName && (val.groupCommonId || val.commonId) && val.address && val.idCardNum) {
        console.log('OCR getOpenAccount信息++++++++++++++++',val)
        this.addOcrInfo(val)
      }

      if (val.userCompanyId && val.flag && val.flag !== "1") {
        if(this.IOS.ios() && val.accountSource && val.accountSource === '4') {
          let newVal = {
            ...val
          }
          newVal.companyId = val.accountSource
          newVal.userCompanyId = val.accountSource
          this.$store.dispatch("getOpenAccount", newVal);
          this.$store.commit("changeLocalId", val.accountSource);
          return
        }
        this.$store.commit("changeLocalId", val.userCompanyId);
      } else {
        if (val.companyId) {
          if(this.IOS.ios() && val.accountSource && val.accountSource === '4') {
            let newVal = {
              ...val
            }
            newVal.companyId = val.accountSource
            newVal.userCompanyId = val.accountSource
            this.$store.dispatch("getOpenAccount", newVal);
            this.$store.commit("changeLocalId", val.accountSource);
            return
          }
          this.$store.commit("changeLocalId", val.companyId);
        }
        if (val.userCompanyId) {
          if(this.IOS.ios() && val.accountSource && val.accountSource === '4') {
              let newVal = {
              ...val
            }
            newVal.companyId = val.accountSource
            newVal.userCompanyId = val.accountSource
            this.$store.dispatch("getOpenAccount", newVal);
            this.$store.commit("changeLocalId", val.accountSource);
            return
          }
          this.$store.commit("changeLocalId", val.userCompanyId);
        }
      }
    },
    addOcrInfo(val) {
      let param = {
          cmsGroupCustomerCommonId: val.groupCommonId || val.commonId,
          certValidDate: val.expireDate,
          idCardAddress: val.address,
          idCardNum: val.idCardNum,
          name: val.scanName,
          gender: val.gender
        };
        this.$post(this.$api.addOcrInfo, param).then((res) => {
          console.log('addOcrInfo返回值:-----',res)
        });
    },
    // 从原生获取用户风险等级
    getUserRiskLevel(risk) {
      this.$store.commit("saveRiskLevel", risk);
    },
    //获取子产品ID
    getChildId(val) {
      if (this.IOS.ios()) {
        val = this.setHeader.subProductId;
      }
      this.$store.dispatch("getProductId", val);
    },
    // 从原生获取barHeight
    getBarHeight(val) {
      if (!this.IOS.ios()) {
        val = JSON.parse(val);
      }
      this.$store.commit("getStatusHeight", val);
    },
    //获得公募基本信息
    publicBaseInfo(val) {
      if (!this.IOS.ios()) {
        val = JSON.parse(val);
      }
      this.$store.commit("getBaseData", val);
    },
    //获取机构详情Id
    getOrgDetailID(val) {
      if (!this.IOS.ios()) {
        val = JSON.parse(val);
      }
      this.$store.commit("getOrgId", val);
    },
    //获得个人中心
    getPersonalCenter(val) {
      if (!this.IOS.ios()) {
        val = JSON.parse(val);
      }
      this.$store.commit("changeGetThemeCode", val);
      if (val.flag === "1") {
        this.$store.commit("changeReturnParam", val.flag);
        if(this.IOS.ios() && val.accountSource && val.accountSource === '4') {
          this.$store.commit("changeLocalId", val.accountSource);
          return
        }
        this.$store.commit("changeLocalId", val.companyId);
      }
    },
    //获得个人账户信息
    getPersonalAccount(val) {
      if (!this.IOS.ios()) {
        val = JSON.parse(val.replace(/\n/g,"\\n").replace(/\r/g,"\\r"));
      }
      let tag;
      val.historyTab ? tag = val.historyTab : tag = '0'
      this.$store.commit("changeRecordActive", tag);
      this.$store.commit("getPersonalAccount", val);
    },
    //新方法--获得个人账户信息
    getNewPersonalAccount(val){
       if (!this.IOS.ios()) {
        val = (JSON.parse(val)).responseData;

      }
      this.$store.commit("getNewPersonalAccount",val);
    },
    //获取申请资产证明信息
    getAssetsApprove(val){
      if (!this.IOS.ios()) {
        val = JSON.parse(val);
      }
      this.$store.commit("getAssetsPageInfo", val);
    },
    //获得个人实名信息
    getPersonalRealInfo(val) {
      if (!this.IOS.ios()) {
        val = JSON.parse(val);
      }
      this.$store.commit("getPersonalRealInfo", val);
    },
  },
  components: {
    Header,
    batchVerifyView
  },
};
</script>
<style scoped lang="scss">
/*  .setHeader{
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    width: 100%;
    height: 100%;
  }
  .setOther{
    overflow-y: scroll;
  }*/
.setHeader {
  position: absolute;
  left: 0;
  right: 0;
  top: 0; //49px
  z-index: 1;
  /*overflow: hidden;*/
  width: 100%;
  height: 100%;
  margin: 0 auto;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  width: 100%;
}
#conentHeight {
  background: #f5f5f5;
  height: calc(100% - 0.78rem);
  margin-top:0.78rem;
}
.setOther {
  overflow-y: auto;
  // position: absolute;
  // width: 100%;
  // height: calc(100% - 0.48rem);
  // background: #f5f5f5;
}
</style>